export default __webpack_public_path__ + "static/kn-3724b9aa98fa4bf29a1eca24b6aa6860.svg";